import actionTypes from '../actionTypes';

export function setViewByFilterAction(payload) {
	return {
		type: actionTypes.SET_VIEWBY_FILTER,
		payload,
	};
}

export function setBreakdownByFilterAction(payload) {
	return {
		type: actionTypes.SET_BREAKDOWNBY_FILTER,
		payload,
	};
}

export function setTimePeriodAction(payload) {
	return {
		type: actionTypes.SET_TIME_PERIOD_FILTER,
		payload,
	};
}

export function setNewTimePeriodAction(payload) {
	return {
		type: actionTypes.SET_NEW_TIME_PERIOD_FILTER,
		payload,
	};
}

export function setExcelDownloadAction(payload) {
	return {
		type: actionTypes.SET_EXCEL_DOWNLOAD,
		payload,
	};
}

export function setEnableDownload(payload) {
	return {
		type: actionTypes.SET_ENABLE_DOWNLOAD,
		payload,
	};
}

export function setViewByType(payload) {
	return {
		type: actionTypes.SET_VIEW_BY_TYPE,
		payload,
	};
}

export function setBreakDownByType(payload) {
	return {
		type: actionTypes.SET_BREAK_DOWN_BY_TYPE,
		payload,
	};
}

export function setCustomAtrributeNames(payload) {
	return {
		type: actionTypes.SET_CUSTOM_ATTRIBUTE_NAMES,
		payload,
	};
}

export function resetFilters() {
	return {
		type: actionTypes.RESET_FILTERS
	};
}
